export const CoreConfig = 'coreConfig';
